import { render, staticRenderFns } from "./announcement-form.vue?vue&type=template&id=44552774&scoped=true"
import script from "./announcement-form.vue?vue&type=script&lang=js"
export * from "./announcement-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44552774",
  null
  
)

export default component.exports